import { useEffect, useRef, useState } from "react";
import "../../css/signin/signin2.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  clickToSubmitButtonWithEnter,
  handleKeyDown,
  handleKeyDownForPasswordInput,
  handlePaste,
  handlePasteForPasswordInput,
} from "../Inputs/handleKeyDown";
import { checkingUsername } from "./CheckingUsername";
import { domain } from "../Links/Links";

function Signup({ theme, setTheme }) {
  const { t } = useTranslation();
  const [fullnameInputValue, setFullnameInputValue] = useState("");
  const [usernameInputValue, setUsernameInputValue] = useState("");
  const [passwordInputValue, setPasswordInputValue] = useState("");

  const [checkingUsernameStatus, setCheckingUsernameStataus] = useState(false);
  const [usernameIsBeing, setUsernameIsBeing] = useState(false);

  const [signupButtonStatus, setSignupButtonStatus] = useState(false);

  const navigate = useNavigate();

  const fullnameInputRef = useRef(null);

  useEffect(() => {
    if (fullnameInputRef.current) {
      fullnameInputRef.current.focus();
    }

    clickToSubmitButtonWithEnter();
  }, []);

  return (
    <div className="signin_main_div">
      <div className="signin_fields_div">
        <div className="signin_title_div">{t("Signup to hiket")}</div>

        <div className="input_div">
          <div>{t("Fullname")}</div>
          <input
            className={`input ${theme}`}
            dir="auto"
            ref={fullnameInputRef}
            onChange={(e) => {
              setFullnameInputValue(e.target.value);
            }}
          ></input>
        </div>

        <div className="input_div">
          <div>{t("Username")}</div>
          <input
            className={`input dir_ltr ${theme} ${usernameIsBeing ? "error" : ""}`}
            onChange={(e) => {
              checkingUsername(e.target.value, setUsernameIsBeing);
              setCheckingUsernameStataus(true);
              setUsernameInputValue(e.target.value);
            }}
            onKeyDown={handleKeyDown}
            onPaste={handlePaste}
          ></input>
          {usernameIsBeing ? (
            <div className="input_error_div">{t("Is being")}</div>
          ) : (
            ""
          )}
        </div>

        <div className="input_div">
          <div>{t("Password")}</div>
          <input
            className={`input dir_ltr ${theme}`}
            onChange={(e) => {
              setPasswordInputValue(e.target.value);
            }}
            onKeyDown={handleKeyDownForPasswordInput}
            onPaste={handlePasteForPasswordInput}
          ></input>
        </div>

        <button
          className={`submit_button ${theme} ${fullnameInputValue && usernameInputValue && passwordInputValue && usernameIsBeing == false ? "active" : ""}`}
          onClick={() => {
            if (
              fullnameInputValue &&
              usernameInputValue &&
              passwordInputValue &&
              usernameIsBeing == false
            ) {
              setSignupButtonStatus(true);

              const xhr = new XMLHttpRequest();
              xhr.open("POST", domain + "/signup_api/", true);

              xhr.withCredentials = true;

              xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                  const data = JSON.parse(xhr.responseText);
                  if (data.ok) {
                    window.location.href = "/";
                  }
                }
              };
              xhr.setRequestHeader("Content-Type", "application/json");

              const data = JSON.stringify({
                fullname: fullnameInputValue,
                username: usernameInputValue,
                password: passwordInputValue,
                system_name: navigator.userAgent,
                app_name: "Web",
                location: "Iran",
              });
              xhr.send(data);
            }
          }}
        >
          {signupButtonStatus ? (
            <img src="/icons/loading.png" className="icon rotate"></img>
          ) : (
            t("Signup")
          )}
        </button>
      </div>

      <div className="buttons_div_in_signin1">
        <button
          className={`simple_button ${theme}`}
          onClick={() => navigate("/signin")}
        >
          {t("Signin")}
        </button>
      </div>

      <div className="buttons_div_in_signin2">
        <button
          className={`simple_button fontSize14 ${theme}`}
          onClick={() => navigate("/rules")}
        >
          {t("Rules")}
        </button>
        <button className={`simple_button fontSize14 ${theme}`}>{t("Language")}</button>
        <button
          className={`simple_button fontSize14 ${theme}`}
          onClick={() => {
            setTheme(theme === "light" ? "night" : "light");
          }}
        >
          {theme === "light" ? t("Night mode") : t("Light mode")}
        </button>
      </div>
    </div>
  );
}

export default Signup;
